module.exports = __webpack_public_path__ + "static/media/识别图片播放背景音.76417400.png";